<template>
	<div class="erji">
		<div class="container">
			<div class="main">
				<div class="party">
					<div class="title-00">
						<h1 class="fl">{{titleName}}</h1>
						<div class="clear"></div>
					</div>
					<div class="erji-content">
						<div class="party-list">
							<!-- <list :listId = "this.childId"></list> -->
							<div class="list01">
								<dl>
									<dd v-for="(item, index) in searchList" :key="index">
										<div class="list01-a" @click='toDetal(item)'>{{item.title}}</div>
										<span class="span_11">{{item.created_at.slice(0,10)}}</span>
									</dd>
								</dl>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'search',
		data(){
			return{
				childId:'',
				titleName:'搜索结果',
				searchList:[]
			}
		},
		methods:{
			//请求分类信息
			// res_menusClass(e){
			// 	this.axios.get('/api/menus/class?id='+e)
			// 		.then(response => {
			// 			// 处理成功情况
			// 			if(response.data.code == 200){
			// 					this.titleName = response.data.reslut.name;
			// 			}
			// 		})
			// 		.catch(error => {
			// 			// 处理错误情况
			// 			console.log(error);
			// 		})
			// },
			//请求检索结果
			res_searchList(e){
				this.axios.get('/api/search?keywords='+e)
					.then(response => {
						// 处理成功情况
						console.log('response',response)
						if(response.data.code == 200){
							this.searchList = response.data.reslut.data;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//跳转详情页
			toDetal(item){
				console.log('跳转详情页',item);
				if(item.name == '党的建设'){
					this.$router.push({
						path:'/detail_nomenu',
						query:{
							category_id:item.category_id,
							id:item.id
						}
					})	
				}else{
					this.$router.push({
						path:'/slider/'+ item.parent_id +'/detail',
						query:{
							category_id:item.category_id,
							id:item.id
						}
					})
				}
				
			}
		},
		created() {
			// this.childId = this.$route.query.category_id;
			console.log('search',this.$route)
			this.res_searchList(this.$route.query.keywords)
			// this.res_menusClass(this.childId);
			
		},
		mounted(){
		
		}
	}
</script>

<style>
</style>